import React from 'react';
import '../css/home.css'; // Common styles for info blocks
import { formatNumberWithCommas } from '../components/formatIntegerWithCommas.js'
import { t } from 'ttag';
import ProgressBar from './ProgressBar'; // Убедитесь, что путь правильный

function Home({ recData, handlesetIndex }) {

    // --- Лицензии ---
    const lic_arr = recData.user_lic.map((element, index) => (
        <div className='h-sub-block' key={index}>
            <div className='h-data-row'>
                <div className='h-data-label'>{element.name}</div>
                <div className='h-data-value'>
                    {formatNumberWithCommas(element.profit, 2)} / {formatNumberWithCommas(element.price, 0)} USDT
                </div>
            </div>
            <ProgressBar
                completed={((element.profit) / element.price) * 100}
                bgColor="#2196f3" // Этот цвет теперь будет работать
                height="10px"
            />
        </div>
    ));

    // --- Баланс ---
    const bal = (
        <div className="h-balance-container">
            <div className="h-info-block">
                <div className="h-info-block-header">{t`Balance`}</div>
                <div className="h-info-block-value">{formatNumberWithCommas(recData.usdt, 0)} USDT</div>
            </div>
            <button className="h-balance-button" onClick={() => { handlesetIndex(3) }}>
                {t`i`}
            </button>
        </div>
    );

    // --- Блок Лицензий ---
    const lic = (
        <div className='h-main-block'>
            <div className='h-block-title'>License</div>
            <div className='h-data-row'>
                <div className='h-data-label'>License Pool</div>
                <div className='h-data-value'>{formatNumberWithCommas(recData.lic_pool, 0)} USDT</div>
            </div>
            <div className='h-data-row'>
                <div className='h-data-label'>Active License:</div>
                <div className='h-data-value'> {recData.user_lic.length === 0 ? "No" : ""}</div>
            </div>
            <div className='h-license-list'>
                {lic_arr}
            </div>
        </div>
    );

    // --- Блок Торговли ---
    const tradeDeposit = recData.user.Trades.length === 0 ? 0 : recData.user.Trades[0].deposit;
    const tradeProfit = recData.user.Trades.length === 0 ? 0 : recData.user.Trades[0].profit;

    const trd = (
        <div className='h-main-block'>
            <div className='h-block-title'>Trade</div>
            <div className='h-data-row'>
                <div className='h-data-label'>Trade Balance:</div>
                <div className='h-data-value'>{formatNumberWithCommas(tradeDeposit, 2)} USDT</div>
            </div>
            <div className='h-data-row'>
                <div className='h-data-label'>Profit:</div>
                <div className='h-data-value'>{formatNumberWithCommas(tradeProfit, 2)} USDT</div>
            </div>
        </div>
    );

    // --- Блок Прибыли (Редизайн) ---
    const prft = (
        <div className='h-main-block h-profit-block'>
            <div className='h-block-title'>Profit</div>

            {/* Главное значение */}
            <div className="h-info-block-header">{t`Total profit:`}</div>
            <div className="h-info-block-value">
                {formatNumberWithCommas(recData.lic_profit + recData.trade_profit, 2)} USDT
            </div>

            {/* Детализация */}
            <div className='h-data-row h-profit-details'>
                <div className='h-data-label'>Trade profit:</div>
                <div className='h-data-value'>{formatNumberWithCommas(recData.trade_profit, 2)} USDT</div>
            </div>
            <div className='h-data-row h-profit-details'>
                <div className='h-data-label'>License profit:</div>
                <div className='h-data-value'>{formatNumberWithCommas(recData.lic_profit, 2)} USDT</div>
            </div>
        </div>
    );

    return (
        <>

            {bal}
            {prft}
            {lic}
            {trd}

        </>
    );
}

export { Home };